import {
  CheckCircle,
  Film,
  Inbox,
  type LucideIcon,
  Megaphone,
  Package,
  Palette,
  RefreshCw,
  Sparkles,
  Zap,
} from 'lucide-react';

import { i18n } from '@/shared/i18n';
import type { BriefType } from './types';

export const BRIEF_TYPE_ICON: Record<BriefType, LucideIcon> = {
  marketing: Megaphone,
  creative: Sparkles,
  design: Palette,
  media: Film,
  content: Zap,
  campaign: Megaphone,
  asset_production: Package,
  rebrief: RefreshCw,
  intake: Inbox,
  approval: CheckCircle,
};

// Labels are getters so each read resolves against the active locale; a plain
// `i18n.t(...)` here would freeze the English string at import time.
export const BRIEF_TYPE_LABEL: Record<BriefType, string> = {
  get marketing() {
    return i18n.t('briefs:brief.constants.marketing');
  },
  get creative() {
    return i18n.t('briefs:brief.constants.creative');
  },
  get design() {
    return i18n.t('briefs:brief.constants.design');
  },
  get media() {
    return i18n.t('briefs:brief.constants.media');
  },
  get content() {
    return i18n.t('briefs:brief.constants.content');
  },
  get campaign() {
    return i18n.t('briefs:brief.constants.campaign');
  },
  get asset_production() {
    return i18n.t('briefs:brief.constants.assetProduction');
  },
  get rebrief() {
    return i18n.t('briefs:brief.constants.rebrief');
  },
  get intake() {
    return i18n.t('briefs:brief.constants.intake');
  },
  get approval() {
    return i18n.t('briefs:brief.constants.approval');
  },
};
